let scNamespace = {
  PAGE: {
    ANY: {name: "any", uri: "/*", id: "sc-page-any", redirect:"/"},
    HOME: {name: "home", uri: "/", id: "sc-page-home", navI18n: "Nav.Seal"},
    PRODUCT: {name:"product", uri: "/product", id: "sc-page-product", navI18n: "Nav.Product"},
    SERVICE: {name:"service", uri: "/service", id: "sc-page-service", navI18n: "Nav.Service"},
    TECHNOLOGY: {name:"technology", uri: "/technology", id: "sc-page-technology", navI18n: "Nav.Tech"},
    ABOUT_US: {name:"about", uri: "/about", id: "sc-page-about", navI18n: "Nav.AboutUs"},
    ROAD_MAP: {name:"roadmap", uri: "/roadmap", id: "sc-page-roadmap", navI18n: "Nav.RoadMap"},
    TEAM: {name:"team", uri: "/team", id: "sc-page-team", navI18n: "Nav.Team"},
  }
}

scNamespace.PAGE.ORDERED = [
  scNamespace.PAGE.HOME,
  // scNamespace.PAGE.PRODUCT,
  scNamespace.PAGE.SERVICE,
  scNamespace.PAGE.TECHNOLOGY,
  scNamespace.PAGE.ROAD_MAP,
  // scNamespace.PAGE.TEAM,
  scNamespace.PAGE.ABOUT_US,
]

export {
  scNamespace
}